import React, { useCallback, useEffect } from 'react';
import { Helmet } from "react-helmet";
import './Home.scss';
import { requestFeaturedArticulos } from '../../store/articulos/articulos.actions';
import { useDispatch, useSelector } from 'react-redux';
import Spinner from '../../core/Spinner/Spinner';
import Articulo from '../../classes/articulo';
import { Familia } from '../../classes/familia';
import ProductItem, { IProductItem } from '../../components/ProductItem/ProductItem';
import Cliente from '../../classes/cliente';
const Home: React.FunctionComponent<{}> = React.memo(() => {
    const { articulos, error, fetching } = useSelector((state: any) => state.articulosStore);
    const cliente: Cliente = useSelector((state: any) => state.authStore.user);
    const familias: Familia[] = useSelector((state: any) => state.familiasStore.familias);
    const listapre: number = cliente && cliente.LISTAPRE;
    const showCart: boolean = cliente !== null;
    const dispatch = useDispatch();
    const fetchData = useCallback(() => {
        dispatch(requestFeaturedArticulos());
    }, [dispatch]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const getProductPrice = (articulo: Articulo): number => {
        switch (listapre) {
            case 1: return articulo.PVENTA_1;
            case 2: return articulo.PVENTA_2;
            case 3: return articulo.PVENTA_3;
            case 4: return articulo.PVENTA_4;
            default: return articulo.PVENTA_2;
        };
    };

    const renderFeaturedProducts = () => {
        if (fetching) {
            return <Spinner>Cargando productos destacados...</Spinner>;
        }

        if (error || !articulos || articulos.length === 0) return;

        return (
            <>
                <h1 className="title">Productos destacados</h1>
                <div className="row">
                    {articulos.map((a: Articulo, index: number) => {
                        const familia: Familia|undefined = familias.find((f: Familia) => f.ID_FLIA === a.ID_FLIA);
                        const product: IProductItem = {
                            codart: a.CODART,
                            desart: a.DESART,
                            familia: familia && familia.NFAMILIA,
                            subfamilia: '',
                            price: getProductPrice(a),
                            imgUrl: a.FILE1,
                            showCart
                        };

                        return <ProductItem key={index} {...product} />
                    })}
                </div>
            </>
        );
    }
    
    return (
        <div>
            <Helmet>
                <title>Linea 2000 | Tienda oficial</title>
                <meta name="description" content="Fabrica, fracciona y distribuye productos de altísima calidad para un mercado cada vez más exigente." />
                <meta name="keywords" content="acido, ácido, destapa cañerias, canieria, cloro, detergente, jabon, distribuidor, mendoza" />
            </Helmet>
            <div className="Home container">
                <img alt="Linea 2000" src="./assets/slider/banner.jpg" />

                <div className="text-container">
                    <h1 className="title">Conociéndonos.</h1>
                    <p className="regular-text">Somos una empresa mendocina que fabrica, fracciona y distribuye productos de altísima calidad para un mercado cada vez más exigente.
                        Para ello, capacitamos a nuestro personal y nos vamos actualizando permanentemente en materias primas para llegar a nuestros clientes con un producto de óptima calidad.</p>
                    <p className="regular-text">Nos sentimos orgullosos de ser líderes en la fabricación de: Ácido muriático, soda caustica, desengrasantes, destapacañerías, entre otros productos.</p>
                    <p className="regular-text">Contamos con toda la gama de productos de limpieza para el hogar y la industria, además de la incorporación de una nueva línea de accesorios para baño y uso personal.</p>
                    <p className="text-big">El personal de Linea2000 trabaja día a día con pasión y compromiso. Nuestro objetivo: lograr abastecer a nuestros clientes con los más variados productos que fabricamos, garantizando la calidad y excelencia.</p>
                </div>

                {renderFeaturedProducts()}
            </div>
        </div>
    );
});

export default Home;